module.exports = __webpack_public_path__ + "static/img/server3.7a2cdc5f.jpg";